/*eslint-disable*/
import React, { useState, useEffect }  from "react";
import { Link } from "react-router-dom";

import CountUp from "react-countup";
import VisibilitySensor from 'react-visibility-sensor';

import IndexNavbar from "../components/Navbars/IndexNavbar.js";



import '../assets/styles/App.css';
import '../assets/styles/tailwind.css';
import "@fontsource/montserrat";

import { ReactComponent as NavbarGradient } from '../assets/img/Rectangle 44.svg';

import { ReactComponent as LargeLogo } from '../assets/img/logo_large_new.svg';
import { ReactComponent as LargeLogoBlue } from '../assets/img/Vela_large_whiteBG.svg';
import { ReactComponent as LogoJumo } from '../assets/img/JUMO_Logo.svg';
import { ReactComponent as LargeGraph } from '../assets/img/LargeGraph.svg';
import { ReactComponent as MobileGraph } from '../assets/img/graph_mobi.svg';



export default function User() {


  const screenSize = (window.innerWidth >= 912);
  const screenSizeTwo = (window.innerWidth >= 1024);

  document.title = "Profile";

  return (
    <>
      <section>
        <IndexNavbar />
      </section>

      <section className="relative grad-1 pb-20">
        <div className="top-0 w-full z-40 absolute">
            <NavbarGradient />
        </div>

        { screenSize ? (
            <div className="bottom-0 w-full h-screen z-40 absolute grad-header">
                <></>
            </div>
            ) : (
            <div className="top-0 w-full h-20-pc z-40 absolute grad-header">
                <></>
            </div>
            )
        }

        <div className="container relative z-40 mx-auto flex">
            <div className="text-center px-8 bottom-0 absolute">
              <h2 className="hl-72 text-white mt-48 px-2">
                Seeing is believing
              </h2>
              <div className={`text-center max-w-1000-px mx-auto ${screenSize && 'mt-6'}`}>
                  <p className="pt-8 md:mt-16 text-white text-24-150">
                      
                  </p>
              </div>

            </div>
        </div>
      </section>

    </>
  );
}

